import * as React from 'react';
import { Redirect } from 'react-router-dom';
import { Button } from 'src/components/atoms';
import { useTranslation } from 'react-i18next';
import { useRedirect } from 'src/hooks';
import { useTheme } from 'styled-components';
import { Message, getReadableIdWithDash } from '../../types';
import {
  BoldHeader,
  Column,
  ColumnGrow,
  InfoRow,
  MessageButton,
  MessageCountBadge,
  MessageListBoxContainer,
} from './MessageListBox.styles';

interface Props {
  organisation: string;
  unreadCount: number;
  lastMessage: Message | undefined;
  reportId: string;
  reportedCategory: string;
}

const MessageListBox = (props: Props) => {
  const { t } = useTranslation();
  const displayReportId = getReadableIdWithDash(props.reportId);
  const { showRedirect, redirectTo, redirect } = useRedirect();
  const theme = useTheme();

  const badgeTextColor = theme.isVaultVariant
    ? theme.newPalette.neutral.N0
    : theme.atlas.semantic.color.type.inverse;
  const badgeBgColor = theme.isVaultVariant
    ? theme.newPalette.red.R300
    : theme.atlas.semantic.color.action.destructive.default;

  if (showRedirect) {
    return <Redirect data-testid={redirectTo} to={`${redirectTo}`} push />;
  }

  return (
    <MessageListBoxContainer
      data-testid={`messages-box-${props.reportId}`}
      to={`/${props.organisation}/open-reporting/messages/${props.reportId}`}
    >
      <InfoRow>
        <ColumnGrow>
          <BoldHeader>
            {t('public.MessageListBox.report')}
            {displayReportId} {props.reportedCategory}
          </BoldHeader>
        </ColumnGrow>
        <Column className="message-box-right">
          <MessageButton>
            <Button
              variant="primary"
              size="medium"
              onClick={(e: React.MouseEvent) => {
                e.stopPropagation();
                redirect(
                  `/${props.organisation}/open-reporting/messages/${props.reportId}`,
                );
              }}
              data-testid={'message-case-manager'}
              width="190px"
            >
              {t('public.PublicReportCard.messageCaseManager')}
              {props.unreadCount > 0 && (
                <MessageCountBadge
                  data-testid="unread-messages"
                  variant="custom"
                  text={`${props.unreadCount}`}
                  color={badgeTextColor}
                  background-color={badgeBgColor}
                />
              )}
            </Button>
          </MessageButton>
        </Column>
      </InfoRow>
    </MessageListBoxContainer>
  );
};

export default MessageListBox;
